export type ControlMetadataForPlaceholders = {
  date: string;
  completedAt: string;
  projectName: string;
  address: string;
  city: string;
  clientName: string;
  mainContractor: string;
};

/** Control-level aggregate counts and percentages used in report templates. */
export type ControlLevelStatisticsForPlaceholders = {
  numberOfPersonnel: number;
  numberOfControlledPersonnel: number;
  numberOfCheckedInAndControlledPersonnel: number;
  percentageOfCheckedInAndControlledPersonnel: number;
  numberOfNotControlledPersonnel: number;
  percentageOfNotControlledPersonnel: number;
  numberOfAdditionalPersonnel: number;
  percentageOfAdditionalPersonnel: number;
  numberOfPersonnelWithInvalidIdentification: number;
  percentageOfPersonnelWithInvalidIdentification: number;
  numberOfPersonnelWithIdCardDeviations: number;
  percentageOfPersonnelWithIdCardDeviations: number;
  numberOfPersonnelWithoutSafetyEquipment: number;
  percentageOfPersonnelWithoutSafetyEquipment: number;
  numberOfPersonnelWithoutWorkPermit: number;
  percentageOfPersonnelWithoutWorkPermit: number;
  numberOfPersonnelWithoutCertificate: number;
  percentageOfPersonnelWithoutCertificate: number;
};

const formatStatValue = (value: number): string => {
  if (Number.isInteger(value)) return String(value);
  return String(Math.round(value * 10) / 10);
};

/**
 * Projects control/project metadata + control-level statistics into a flat
 * placeholder map for `{{key}}` interpolation. No personal identifiers.
 */
export function projectStatisticsPlaceholders(
  metadata: ControlMetadataForPlaceholders,
  statistics: ControlLevelStatisticsForPlaceholders
): Record<string, string> {
  return {
    date: metadata.date,
    completedAt: metadata.completedAt,
    projectName: metadata.projectName,
    address: metadata.address,
    city: metadata.city,
    clientName: metadata.clientName,
    mainContractor: metadata.mainContractor,
    numberOfPersonnel: formatStatValue(statistics.numberOfPersonnel),
    numberOfControlledPersonnel: formatStatValue(
      statistics.numberOfControlledPersonnel
    ),
    numberOfCheckedInAndControlledPersonnel: formatStatValue(
      statistics.numberOfCheckedInAndControlledPersonnel
    ),
    percentageOfCheckedInAndControlledPersonnel: formatStatValue(
      statistics.percentageOfCheckedInAndControlledPersonnel
    ),
    numberOfNotControlledPersonnel: formatStatValue(
      statistics.numberOfNotControlledPersonnel
    ),
    percentageOfNotControlledPersonnel: formatStatValue(
      statistics.percentageOfNotControlledPersonnel
    ),
    numberOfAdditionalPersonnel: formatStatValue(
      statistics.numberOfAdditionalPersonnel
    ),
    percentageOfAdditionalPersonnel: formatStatValue(
      statistics.percentageOfAdditionalPersonnel
    ),
    numberOfPersonnelWithInvalidIdentification: formatStatValue(
      statistics.numberOfPersonnelWithInvalidIdentification
    ),
    percentageOfPersonnelWithInvalidIdentification: formatStatValue(
      statistics.percentageOfPersonnelWithInvalidIdentification
    ),
    numberOfPersonnelWithIdCardDeviations: formatStatValue(
      statistics.numberOfPersonnelWithIdCardDeviations
    ),
    percentageOfPersonnelWithIdCardDeviations: formatStatValue(
      statistics.percentageOfPersonnelWithIdCardDeviations
    ),
    numberOfPersonnelWithoutSafetyEquipment: formatStatValue(
      statistics.numberOfPersonnelWithoutSafetyEquipment
    ),
    percentageOfPersonnelWithoutSafetyEquipment: formatStatValue(
      statistics.percentageOfPersonnelWithoutSafetyEquipment
    ),
    numberOfPersonnelWithoutWorkPermit: formatStatValue(
      statistics.numberOfPersonnelWithoutWorkPermit
    ),
    percentageOfPersonnelWithoutWorkPermit: formatStatValue(
      statistics.percentageOfPersonnelWithoutWorkPermit
    ),
    numberOfPersonnelWithoutCertificate: formatStatValue(
      statistics.numberOfPersonnelWithoutCertificate
    ),
    percentageOfPersonnelWithoutCertificate: formatStatValue(
      statistics.percentageOfPersonnelWithoutCertificate
    ),
  };
}
